import React from "react";
import NavBar from "./components/NavBar";
import PhotoSearch from "./components/PhotoSearch";
import "./App.css";

function App() {
  return (
    <div className="App">
      <NavBar />
      <br />
      <PhotoSearch />
    </div>
  );
}

export default App;
